import { createApp } from "vue";
import App from "./App.vue";
import { createStore } from "vuex";
import state from "@/store/state.js";
import mutations from "@/store/mutations.js";
import getters from "@/store/getters.js";
import actions from "@/store/actions.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/js/bootstrap.min.js";

// import 'owl.carousel/dist/owl.carousel.js'
// import 'owl.carousel/dist/assets/owl.carousel.css'

import "@/assets/css/main-lk.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import LkButton from "@/components/controls/LkButton.vue";
import LkCheckbox from "@/components/controls/LkCheckbox.vue";
import LkCmdLink from "@/components/controls/LkCmdLink.vue";
import LkMaskedField from "@/components/controls/LkMaskedField.vue";
import router from "@/router.js";
import VueMonthPicker from 'vue-month-picker'
//import { MonthPickerInput } from 'vue-month-picker'


const store = createStore({
  state,
  mutations,
  getters,
  actions,
});

const app = createApp(App);

app.component("LkButton", LkButton);
app.component("LkCheckbox", LkCheckbox);
app.component("LkCmdLink", LkCmdLink);
app.component("LkMaskedField", LkMaskedField);

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.loggedIn)) {
    if (!store.getters.loggedIn) {
      next({ name: "login", query: { redirect: to.fullPath } });
    } else {
      if (to.name === "services" && !to.params.page) {
        router.push("/services/1");
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

router.addRoute({
  path: "/logout",
  name: "logout",
  beforeEnter(to, from, next) {
    store.commit("setToken", null);
    store.commit("setLoginSuccess", null);
    store.commit("setLoginError", null);
    store.commit("setReports", null);
    store.commit("setPayments", null);
    store.commit("setDiscounts", null);
    store.commit("setBalances", null);
    store.commit("setGroupDiscounts", null);
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    router.replace("/login");
    let redirect = from.fullPath;
    const index = from.fullPath.indexOf("?");
    if (index > 0) {
      const params = new URLSearchParams(from.fullPath.substr(index));
      redirect = params.get("redirect") || redirect;
    }
    next({
      path: "/login",
      query: { redirect: redirect },
    });
  },
});

app.use(store);
app.use(router);
app.use(VueMonthPicker);
//app.use(MonthPickerInput);

app.mount("#app");
